// extracted by mini-css-extract-plugin
export var cartIcon = "_l7-0";
export var cartIconContainer = "_l7-1";